import { MsalService } from '@azure/msal-angular';

/**
 * Initialize MSAL before app starts
 * This ensures MSAL is ready before routing and auth guards run
 */
export function initializeMsal(msalService: MsalService): () => Promise<void> {
  return async () => {
    console.log('🔐 APP_INITIALIZER: Initializing MSAL...');
    try {
      await msalService.instance.initialize();
      console.log('✅ APP_INITIALIZER: MSAL initialized successfully');
      
      // Handle redirect promise if coming back from Azure AD
      const response = await msalService.instance.handleRedirectPromise();
      if (response) {
        console.log('✅ APP_INITIALIZER: Redirect handled, user logged in:', response.account?.username);
      } else {
        console.log('ℹ️ APP_INITIALIZER: No redirect response (normal page load)');
      }
    } catch (error) {
      console.error('❌ APP_INITIALIZER: MSAL initialization failed:', error);
      throw error; // This will prevent app from starting if MSAL fails
    }
  };
}
